export const rankingData = [
  { rank: 1, title: '顶流明星疑似恋情曝光，工作室回应引热议', heat: '986万', tag: '爆', trend: 'up' },
  { rank: 2, title: '某知名综艺节目录制现场突发意外状况', heat: '872万', tag: '热', trend: 'up' },
  { rank: 3, title: '年度影视盛典红毯造型大盘点', heat: '765万', tag: '热', trend: 'up' },
  { rank: 4, title: '某男团成员深夜发文疑似回应解散传闻', heat: '698万', tag: '新', trend: 'down' },
  { rank: 5, title: '新剧开播收视率创新高，主演演技获好评', heat: '543万', tag: '热', trend: 'up' },
  { rank: 6, title: '知名导演新片选角引争议，网友热议不断', heat: '487万', tag: '新', trend: 'down' },
];

export const updatesData = [
  { time: '10分钟前', title: '某女星机场素颜照流出，真实状态引网友疯狂讨论', tag: '最新' },
  { time: '28分钟前', title: '综艺节目录制路透曝光，飞行嘉宾阵容豪华', tag: '路透' },
  { time: '1小时前', title: '知名博主爆某剧组拍摄趣事，粉丝集体围观', tag: '爆料' },
  { time: '2小时前', title: '音乐榜单更新，新歌空降冠军引发乐评人关注', tag: '音乐' },
  { time: '3小时前', title: '某品牌代言人官宣在即，多重线索指向当红艺人', tag: '代言' },
  { time: '5小时前', title: '粉丝后援会联合声明引关注，官方尚未回应', tag: '粉丝' },
  { time: '7小时前', title: '电影节入围名单公布，国产片表现亮眼', tag: '影视' },
];

export const topicsData = [
  { name: '流量明星恋情', heat: '1286万帖', color: 'primary' },
  { name: '综艺录制事故', heat: '965万帖', color: 'accent' },
  { name: '年度影视盛典', heat: '843万帖', color: 'primary' },
  { name: '男团解散传闻', heat: '721万帖', color: 'secondary' },
  { name: '新剧收视率', heat: '658万帖', color: 'accent' },
  { name: '机场素颜照', heat: '532万帖', color: 'primary' },
  { name: '音乐榜新歌', heat: '476万帖', color: 'secondary' },
  { name: '品牌代言人', heat: '398万帖', color: 'accent' },
  { name: '粉丝后援会', heat: '312万帖', color: 'primary' },
];

export const carouselData = [
  {
    title: '独家揭秘：当红小生背后的经纪团队运作内幕',
    desc: '深入了解娱乐圈幕后的专业推手，解密明星走红背后的故事与策略。',
    tag: '深度',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20entertainment%20industry%20behind%20the%20scenes%2C%20warm%20coral%20and%20gold%20tones%2C%20business%20team%20meeting%20with%20creative%20energy%2C%20modern%20flat%20design%2C%20abstract%20geometric%20elements%2C%20no%20text%2C%20magazine%20editorial%20style&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '流量时代的粉丝经济：从打投到品牌代言全解析',
    desc: '粉丝力量如何改变娱乐圈商业格局，数据背后的趋势与思考。',
    tag: '分析',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20fan%20economy%20and%20social%20media%20influence%2C%20warm%20amber%20and%20coral%20colors%2C%20crowd%20of%20supporters%20with%20glowing%20digital%20elements%2C%20modern%20flat%20design%2C%20abstract%20data%20visualization%2C%20editorial%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '综艺节目二十年：从棚内录制到全媒体互动的进化史',
    desc: '回顾中国综艺节目的变迁历程，看内容形态如何迭代升级。',
    tag: '回顾',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20television%20variety%20show%20evolution%20through%20decades%2C%20warm%20retro%20to%20modern%20transition%2C%20gold%20and%20coral%20tones%2C%20TV%20screens%20morphing%20into%20smartphones%2C%20modern%20flat%20design&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '年度十大娱乐事件盘点：那些牵动全网的热搜时刻',
    desc: '回望过去一年中让人印象最深刻的娱乐圈大事，每一件都曾刷爆你的朋友圈。',
    tag: '盘点',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20top%20entertainment%20news%20highlights%20collage%2C%20warm%20coral%20and%20golden%20tones%2C%20newspaper%20clippings%20and%20headlines%20in%20abstract%20composition%2C%20modern%20flat%20design%2C%20dramatic%20layout&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '演技派的春天：实力演员崛起背后的行业新风向',
    desc: '流量褪去后，演技派演员正在赢得更多机会，行业回归内容本质。',
    tag: '趋势',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20actor%20performing%20on%20stage%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20coral%20tones%2C%20theatrical%20spotlight%20effect%2C%20modern%20flat%20design%20with%20texture%2C%20editorial%20magazine%20quality&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const cardsData = [
  {
    title: '某顶流被拍到与神秘女子同行，粉丝：终于等到这一天',
    category: '明星动态',
    time: '2小时前',
    excerpt: '据目击者称，两人全程举止亲密，疑似已经交往多时。工作室目前尚未对该事件进行回应，粉丝群体已经沸腾。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20celebrity%20walking%20in%20urban%20setting%20with%20paparazzi%20vibe%2C%20warm%20coral%20and%20gold%20tones%2C%20mysterious%20atmosphere%2C%20modern%20flat%20design%2C%20editorial%20style%2C%20abstract%20city%20background&width=800&height=450&seq=card-01&orientation=landscape',
  },
  {
    title: '新综艺首期录制完成，节目组：这将是一档现象级作品',
    category: '综艺资讯',
    time: '4小时前',
    excerpt: '节目总导演接受采访时表示，本季在内容和形式上都做了大胆创新，有望成为今年综艺市场的一匹黑马。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20TV%20variety%20show%20production%20set%20with%20cameras%20and%20lights%2C%20warm%20golden%20and%20coral%20tones%2C%20behind%20the%20scenes%20atmosphere%2C%20modern%20flat%20design%2C%20energetic%20composition&width=800&height=450&seq=card-02&orientation=landscape',
  },
  {
    title: '歌手新专辑意外泄露部分曲目，公司紧急发布声明',
    category: '音乐圈',
    time: '6小时前',
    excerpt: '泄露音源在社交平台迅速传播，粉丝呼吁大家尊重版权等待正式发布，公司已启动法律程序追查泄露源头。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20music%20album%20leak%20theme%2C%20vinyl%20records%20and%20digital%20glitch%20effects%2C%20warm%20amber%20and%20coral%20tones%2C%20modern%20flat%20design%2C%20mysterious%20atmosphere%2C%20editorial%20quality&width=800&height=450&seq=card-03&orientation=landscape',
  },
  {
    title: '某知名导演发文暗讽行业乱象，多位业内人士力挺',
    category: '影视圈',
    time: '8小时前',
    excerpt: '该导演在社交平台发布长文，直指当前影视行业中存在的选角问题，引发行业内广泛讨论与反思。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20film%20director%20working%20on%20set%20with%20dramatic%20lighting%2C%20warm%20coral%20tones%2C%20cinematic%20atmosphere%2C%20modern%20flat%20design%2C%20editorial%20magazine%20style%2C%20movie%20camera%20silhouette&width=800&height=450&seq=card-04&orientation=landscape',
  },
  {
    title: '品牌代言争夺战背后：一纸合约价值几何？',
    category: '商业观察',
    time: '12小时前',
    excerpt: '据业内人士透露，头部艺人代言费用逐年攀升，品牌方在明星选择上亦愈加谨慎，市场正在发生微妙变化。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20luxury%20brand%20endorsement%20contract%20and%20celebrity%20partnership%2C%20warm%20gold%20and%20coral%20tones%2C%20business%20meeting%20atmosphere%2C%20modern%20flat%20design%2C%20glamorous%20abstract%20elements&width=800&height=450&seq=card-05&orientation=landscape',
  },
  {
    title: '新人演员凭一部剧爆红，制片方透露选角幕后故事',
    category: '星闻速递',
    time: '1天前',
    excerpt: '从默默无闻到一夜爆红，这位新人演员的经历堪称现实版灰姑娘，该剧播出后收视与口碑双丰收。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20rising%20star%20actor%20on%20stage%20receiving%20spotlight%2C%20warm%20golden%20and%20coral%20tones%2C%20breakthrough%20moment%2C%20modern%20flat%20design%2C%20theatrical%20atmosphere%2C%20editorial%20quality&width=800&height=450&seq=card-06&orientation=landscape',
  },
];

export const commentsData = [
  {
    name: '吃瓜不嫌事大',
    time: '15分钟前',
    content: '这个瓜我吃了三天了，每天都有新进展，比追剧还刺激！坐等后续反转。',
    likes: 3281,
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20watermelon%20icon%20on%20warm%20coral%20background%2C%20simple%20flat%20design%2C%20kawaii%20style%2C%20centered%20composition&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '娱乐观察员',
    time: '32分钟前',
    content: '作为业内人士说一句，这个圈子的水比大家想象的深得多，很多事不是表面看到的那样。默默吃瓜就好。',
    likes: 2103,
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20detective%20magnifying%20glass%20icon%20on%20warm%20golden%20background%2C%20simple%20flat%20design%2C%20playful%20style%2C%20centered%20composition&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '八卦研究员',
    time: '1小时前',
    content: '整理了一下时间线，感觉这里面还有很多细节没有曝光出来，期待更多料被挖出来！',
    likes: 1892,
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20research%20notes%20icon%20on%20warm%20terracotta%20background%2C%20simple%20flat%20design%2C%20academic%20playful%20style%2C%20centered%20composition&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
  {
    name: '前排出售瓜子',
    time: '2小时前',
    content: '每次来吃瓜官网都能吃到最新鲜的瓜，比别的地方快太多了，已经推荐给身边所有朋友了！',
    likes: 1547,
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20sunflower%20seed%20snack%20icon%20on%20warm%20amber%20background%2C%20simple%20flat%20design%2C%20fun%20style%2C%20centered%20composition&width=80&height=80&seq=avatar-04&orientation=squarish',
  },
  {
    name: '理性吃瓜人',
    time: '3小时前',
    content: '建议大家先不要急着站队，等官方回应出来再说。不过这个瓜确实够劲爆，值得持续关注。',
    likes: 1023,
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20thinking%20person%20icon%20on%20warm%20peach%20background%2C%20simple%20flat%20design%2C%20contemplative%20style%2C%20centered%20composition&width=80&height=80&seq=avatar-05&orientation=squarish',
  },
];

export const indexData = [
  { title: '明星恋情', count: 128, icon: 'ri-heart-line' },
  { title: '综艺节目', count: 96, icon: 'ri-tv-line' },
  { title: '影视剧集', count: 115, icon: 'ri-film-line' },
  { title: '音乐动态', count: 87, icon: 'ri-music-line' },
  { title: '时尚造型', count: 73, icon: 'ri-shirt-line' },
  { title: '粉丝文化', count: 64, icon: 'ri-user-star-line' },
  { title: '行业观察', count: 52, icon: 'ri-bar-chart-line' },
];

export const featureData = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最新',
    desc: '7×24小时实时追踪全网娱乐八卦热点，今日吃瓜、实时八卦一手掌握，绝不错过任何一个热门瓜料。',
  },
  {
    icon: 'ri-timer-line',
    title: '每日更新',
    desc: '新鲜瓜料每日不停更新，本周热门瓜实时汇总，确保您吃到的永远是最新鲜的娱乐资讯。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '一手瓜源',
    desc: '多渠道交叉验证，快速获取一手娱乐资讯，在51吃瓜官网在线吃到最真实可靠的瓜。',
  },
];

export const faqData = [
  {
    q: '吃瓜官网是什么？',
    a: '吃瓜官网是51吃瓜官网旗下的娱乐资讯聚合平台，专注提供全网最新吃瓜资讯、今日吃瓜、实时八卦等内容。我们汇聚全网热门话题，让您一站式了解娱乐圈最新动态，是广大吃瓜爱好者的首选资讯入口。',
  },
  {
    q: '怎么第一时间吃到最新瓜？',
    a: '访问51吃瓜官网在线首页，即可看到实时更新的热门瓜料和最新动态。我们的编辑团队全天候追踪全网热点，确保今日吃瓜内容在第一时间呈现给您。建议收藏网址，随时刷新获取本周热门瓜。',
  },
  {
    q: '网站内容多久更新一次？',
    a: '吃瓜官网保持高频更新节奏，新鲜瓜料几乎实时推送。编辑团队24小时轮班制，从早到晚持续追踪全网娱乐资讯，确保您在任何时候访问都能看到最新八卦和实时热点。',
  },
  {
    q: '可以投稿爆料吗？',
    a: '当然可以！我们欢迎广大网友提供新鲜瓜料和独家线索。您可以通过页面底部的联系我们区域提交投稿信息，我们的编辑团队会对每一份投稿认真审核，一经采用将标注来源并给予感谢。',
  },
];

export const mediaData = [
  {
    title: '揭秘明星天价片酬背后的资本游戏',
    duration: '12:35',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20film%20industry%20finance%20and%20money%20theme%2C%20warm%20gold%20and%20coral%20tones%2C%20movie%20clapperboard%20with%20currency%20symbols%2C%20modern%20flat%20design%2C%20editorial%20style%2C%20abstract%20financial%20elements&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '粉丝应援文化：从线下到线上的进化之路',
    duration: '08:22',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20fan%20support%20culture%20with%20lightsticks%20and%20banners%2C%20warm%20coral%20and%20amber%20tones%2C%20concert%20atmosphere%2C%20modern%20flat%20design%2C%20energetic%20crowd%20abstract%20composition&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '选秀节目十年：造星工业的变与不变',
    duration: '15:40',
    views: '85万',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20talent%20show%20stage%20with%20spotlights%20and%20audience%2C%20warm%20golden%20and%20coral%20tones%2C%20competition%20atmosphere%2C%20modern%20flat%20design%2C%20dramatic%20lighting%20effect&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '流量明星转型之路：从偶像到演员有多远',
    duration: '10:18',
    views: '73万',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20performer%20transformation%20from%20idol%20to%20actor%2C%20warm%20coral%20tones%2C%20dual%20personality%20concept%2C%20modern%20flat%20design%2C%20artistic%20split%20composition%2C%20editorial%20quality&width=800&height=500&seq=media-04&orientation=landscape',
  },
];